export const WA_NUMBER = '59177858921';

export const WA_CONVERSATION_MSG =
  'Hola, quiero agendar una conversación sobre nuestros sistemas.';

export const WA_CONVERSATION_URL = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_CONVERSATION_MSG)}`;

export const CONTACT_EMAIL = 'info@devssoft.com';

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/devssoft',
  linkedin: 'https://www.linkedin.com/company/devssoftwebdevelopment',
};
